import { createReducer } from 'redux-act'

import State from './types'
import {
    decrementCountTransport,
    incrementCountTransport,
    setCountTransport,
    initGuestFavorites,
    addGuestFavorite,
    removeGuestFavorite,
} from './actions'
import initialState from './state'

const _setCountTransport = (state: State, payload: number | undefined): State => ({
    ...state,
    count: payload,
})

const _incrementCountTransport = (state: State): State => ({
    ...state,
    count: state.count ? state.count + 1 : 1,
})

const _decrementCountTransport = (state: State): State => ({
    ...state,
    count: state.count && state.count > 1 ? state.count - 1 : undefined,
})

const _initGuestFavorites = (state: State, payload: string[]): State => ({
    ...state,
    guestFavoriteListings: payload,
})

const _addGuestFavorite = (state: State, listingId: string): State => {
    if (state.guestFavoriteListings.includes(listingId)) {
        return state // Prevent duplicates
    }
    return {
        ...state,
        guestFavoriteListings: [...state.guestFavoriteListings, listingId],
    }
}

const _removeGuestFavorite = (state: State, listingId: string): State => ({
    ...state,
    guestFavoriteListings: state.guestFavoriteListings.filter(id => id !== listingId),
})

const reducer = createReducer<State>(on => {
    on(setCountTransport, _setCountTransport)
    on(incrementCountTransport, _incrementCountTransport)
    on(decrementCountTransport, _decrementCountTransport)
    on(initGuestFavorites, _initGuestFavorites)
    on(addGuestFavorite, _addGuestFavorite)
    on(removeGuestFavorite, _removeGuestFavorite)
}, initialState)

export default reducer
